<template>
  <div id="sidebar-wrapper">
    <ul class="sidebar-nav">
      <li class="sidebar-brand">
        <img
          src="../assets/CarnivalUK_Logo.png"
          width="40"
          height="40"
          style="margin-left: -20px"
        />
      </li>

      <!-- monitor dashboard icon -->

      <li>
        <a @click="onMenuClick('/monitordashboard')">
          <div>
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/co2-icon.svg" />
              </div>

              <template #content>
                <div style="width: 140px; text-align: left">
                  Monitor Dashboard
                </div>
              </template>
            </Popper>
          </div>
        </a>
      </li>

      <!-- monitor detail icon -->

      <li>
        <a @click="onMenuClick('/monitordetail')">
          <div style="cursor: pointer">
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/monitor-detail-icon.svg" />
              </div>
              <template #content>
                <div style="width: 120px; text-align: left">Monitor Detail</div>
              </template>
            </Popper>
          </div>
        </a>
      </li>
      <!-- monitor detail icon -->

      <!-- prediction dashboard -->

   <li>
        <a @click="onMenuClick('/predictiondashboard')">
          <div style="cursor: pointer">
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/prediction-monitor-icon.svg" />
              </div>
              <template #content>
                <div style="width: 150px; text-align: left">
                  Prediction Dashboard
                </div>
              </template>
            </Popper>
          </div>
        </a>
      </li>
      <!-- prediction dashboard -->

      <!-- prediction details -->

   <li>
        <a @click="onMenuClick('/PredictionDetail')">
          <div style="cursor: pointer">
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/prediction-detail-icon.svg" />
              </div>
              <template #content>
                <div style="width: 140px; text-align: left">
                  Prediction Detail
                </div>
              </template>
            </Popper>
          </div>
        </a>
      </li>
      <!-- prediction detail -->

      <!-- reports-->

    <li>
        <a @click="onMenuClick('/reports')">
          <div style="cursor: pointer">
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/reports-icon.svg" />
              </div>
              <template #content>
                <div style="width: 80px; text-align: left">Reports</div>
              </template>
            </Popper>
          </div>
        </a>
      </li>
      <!-- reports -->

      <!-- admin -->
       <li v-if="isAdmin">
        <a @click="onMenuClick('/administration-dashboard')">
          <div style="cursor: pointer">
            <Popper
              placement="right"
              hover="true"
              offsetDistance="10"
              openDelay="200"
              closeDelay="100"
            >
              <div style="margin-left: -50px">
                <img src="../assets/admin-icon.svg" />
              </div>
              <template #content>
                <div style="width: 140px; text-align: left">Administration</div>
              </template>
            </Popper>
          </div>
        </a>
      </li>
      <!--  admin ikonidio -->
    </ul>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Popper from "vue3-popper";
import TokenService from "../services/token.service";

export default {
  components: {
    Popper,
  },
  name: "SideBarMenu",
  props: {
    title: String,
  },
  data() {
    return {};
  },
  computed: {
    isAdmin() {
      if(sessionStorage.getItem("user")==null){
        return false;
      }
      let user=TokenService.getUser();
  let role=user.role;

if(role>0){
  return true;
}else{
  return false;
}
    },
  },
  created() {},
  methods: {
    onMenuClick(link) {
      this.$router.push(link);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
